import React from 'react'
import { Box, DialogTitle, useTheme } from '@mui/material'
import { dialogTitleStyles } from '../../styles/utilities'
import { moduleColors } from '../../theme/tokens'
import { styled } from '@mui/material/styles'
import GroboticPng from '../../images/Grobotic png.png'
import GroboticLight from '../../images/Grobotic png-lightmode.png'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'

const DialogIcon = styled('img')({
  width: 50,
  height: 50,
  borderRadius: '50%',
})

const boxStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}

const CreateOrganizationHeader = ({ context, onToggleInfo }: { context: any; onToggleInfo?: any }) => {
  const theme = useTheme()
  return (
    <Box sx={boxStyles}>
      <DialogIcon src={theme.palette.mode === 'dark' ? GroboticPng : GroboticLight} />
      <Box sx={boxStyles}>
        <DialogTitle sx={dialogTitleStyles(theme)}>{context}</DialogTitle>
        <CorporateFareIcon
          sx={{
            color: moduleColors.organizations,
          }}
        />
      </Box>
    </Box>
  )
}

export default CreateOrganizationHeader
